import React from 'react';

const drips = [
  { left: '8%', delay: '0s', height: '28px', width: '5px' },
  { left: '15%', delay: '0.4s', height: '18px', width: '4px' },
  { left: '23%', delay: '0.8s', height: '35px', width: '6px' },
  { left: '31%', delay: '0.2s', height: '22px', width: '4px' },
  { left: '40%', delay: '1.1s', height: '30px', width: '5px' },
  { left: '48%', delay: '0.6s', height: '15px', width: '3px' },
  { left: '57%', delay: '0.9s', height: '40px', width: '7px' },
  { left: '65%', delay: '0.3s', height: '20px', width: '4px' },
  { left: '73%', delay: '1.3s', height: '32px', width: '5px' },
  { left: '81%', delay: '0.7s', height: '24px', width: '4px' },
  { left: '89%', delay: '0.1s', height: '38px', width: '6px' },
  { left: '95%', delay: '1s', height: '16px', width: '3px' },
];

export default function BloodDrips() {
  return (
    <div className="absolute top-0 left-0 right-0 h-12 pointer-events-none overflow-hidden" aria-hidden="true">
      {drips?.map((drip, i) => (
        <div
          key={`drip-${i + 1}`}
          className="drip-decoration"
          style={{
            left: drip?.left,
            animationDelay: drip?.delay,
            maxHeight: drip?.height,
            width: drip?.width,
            animationDuration: `${2 + i * 0.3}s`,
          }}
        />
      ))}
    </div>
  );
}